<script setup lang="ts">
import { useTranslation } from 'i18next-vue'
import liff from '@line/liff'

interface Props {
  showLimit: boolean
  showPostpone: boolean
}

interface Emits {
  (e: 'closeLimit'): void
  (e: 'closePostpone'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const { t } = useTranslation()

const handleCloseLimit = () => {
  emit('closeLimit')
  if (liff.isInClient()) liff.closeWindow()
}

const handleClosePostpone = () => {
  emit('closePostpone')
  if (liff.isInClient()) liff.closeWindow()
}
</script>

<template>
  <!-- Limit Dialog -->
  <van-dialog :show="showLimit" :show-confirm-button="false" style="text-align: center">
    <div style="padding: 20px">
      <van-icon style="margin: 15px 0px" name="clear" size="72" color="red" />
      <p class="title">{{ t('appointment.error.cannot_create_title') }}</p>
      <p class="sub-text">{{ t('appointment.error.cannot_create_detail') }}</p>
      <p class="sub-text">{{ t('appointment.error.contact_admin') }}</p>
      <van-button round block type="danger" style="color: white" @click="handleCloseLimit">
        {{ t('close') }}
      </van-button>
    </div>
  </van-dialog>

  <!-- Postpone Dialog -->
  <van-dialog :show="showPostpone" :show-confirm-button="false" style="text-align: center">
    <div style="padding: 20px">
      <van-icon style="margin: 15px 0px" name="info" size="72" color="orange" />
      <p class="title">{{ t('appointment.error.cannot_postpone_title') }}</p>
      <p class="sub-text">{{ t('appointment.error.cannot_postpone_detail') }}</p>
      <p class="sub-text">{{ t('appointment.error.contact_admin') }}</p>
      <van-button round block color="orange" style="color: white" @click="handleClosePostpone">
        {{ t('close') }}
      </van-button>
    </div>
  </van-dialog>
</template>

<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
}

.sub-text {
  font-size: 14px;
  margin: 12px 0px;
  white-space: pre-line;
}
</style>
